import {SpinnerBackgroundDefaultBox} from './spinner-background.default.box';
import {styledByTheme} from "../../../../themes/architecture/styled-by-theme";
import {SpinnerBackgroundCasino777Box} from "./spinner-background.casino777.box";
import {SpinnerBackgroundCIPBox} from "./spinner-background.cip.box";
import {SpinnerBackgroundCISBox} from "./spinner-background.cis.box";
import {SpinnerBackgroundMrGreenBox} from "./spinner-background.mrgreen.box";

export const SpinnerBackgroundBox =  styledByTheme(SpinnerBackgroundDefaultBox)
                                    .forCasino777(SpinnerBackgroundCasino777Box)
                                    .forCip(SpinnerBackgroundCIPBox)
                                    .forWsopCip(SpinnerBackgroundCIPBox)
                                    .forCis(SpinnerBackgroundCISBox)
                                    .forMrGreen(SpinnerBackgroundMrGreenBox)
                                    .apply();